import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const RegisterPage = lazy(() => import('../pages/auth/register/page'));
const MyPage = lazy(() => import('../pages/mypage/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const CheckoutSuccessPage = lazy(() => import('../pages/checkout/success/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminProductsPage = lazy(() => import('../pages/admin/products/page'));
const AdminUsersPage = lazy(() => import('../pages/admin/users/page'));
const AdminOrdersPage = lazy(() => import('../pages/admin/orders/page'));
const AdminSalesPage = lazy(() => import('../pages/admin/sales/page'));
const AdminTransactionsPage = lazy(() => import('../pages/admin/transactions/page'));
const AdminProductFormPage = lazy(() => import('../pages/admin/product-form/page'));
const AdminPasswordChangePage = lazy(() => import('../pages/admin/password-change/page'));
const AdminDashboardNewPage = lazy(() => import('../pages/admin/admin-dashboard/page'));
const AdminMembersPage = lazy(() => import('../pages/admin/members/page'));
const AdminSmsSendPage = lazy(() => import('../pages/admin/sms-send/page'));
const AdminSmsLogsPage = lazy(() => import('../pages/admin/sms-logs/page'));
const AdminSettingsPage = lazy(() => import('../pages/admin/settings/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/auth/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/register',
    element: <RegisterPage />,
  },
  {
    path: '/mypage',
    element: <MyPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/product/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/checkout/success',
    element: <CheckoutSuccessPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardNewPage />,
  },
  {
    path: '/admin/members',
    element: <AdminMembersPage />,
  },
  {
    path: '/admin/sms-send',
    element: <AdminSmsSendPage />,
  },
  {
    path: '/admin/sms-logs',
    element: <AdminSmsLogsPage />,
  },
  {
    path: '/admin/settings',
    element: <AdminSettingsPage />,
  },
  {
    path: '/admin/products',
    element: <AdminProductsPage />,
  },
  {
    path: '/admin/users',
    element: <AdminUsersPage />,
  },
  {
    path: '/admin/orders',
    element: <AdminOrdersPage />,
  },
  {
    path: '/admin/sales',
    element: <AdminSalesPage />,
  },
  {
    path: '/admin/transactions',
    element: <AdminTransactionsPage />,
  },
  {
    path: '/admin/product-form',
    element: <AdminProductFormPage />,
  },
  {
    path: '/admin/password-change',
    element: <AdminPasswordChangePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
